var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 2.75C6.142 2.75 2 6.89 2 11.998C2 17.106 6.142 21.246 11.25 21.246C13.4439 21.2506 15.5672 20.4711 17.237 19.048L20.718 22.528C20.7867 22.6017 20.8695 22.6608 20.9615 22.7018C21.0535 22.7428 21.1528 22.7648 21.2535 22.7666C21.3542 22.7684 21.4542 22.7498 21.5476 22.7121C21.641 22.6744 21.7258 22.6183 21.797 22.547C21.8683 22.4758 21.9244 22.391 21.9621 22.2976C21.9998 22.2042 22.0184 22.1042 22.0166 22.0035C22.0148 21.9028 21.9928 21.8035 21.9518 21.7115C21.9108 21.6195 21.8517 21.5367 21.778 21.468L18.298 17.988C19.7232 16.318 20.5042 14.1934 20.5 11.998C20.5 6.89 16.358 2.75 11.25 2.75ZM3.5 11.998C3.50053 9.94292 4.31728 7.97219 5.77063 6.51922C7.22398 5.06624 9.19492 4.25 11.25 4.25C12.278 4.23348 13.2989 4.42169 14.2534 4.80365C15.2079 5.18561 16.0769 5.75369 16.8097 6.47479C17.5425 7.1959 18.1244 8.05561 18.5217 9.00386C18.9189 9.9521 19.1235 10.9699 19.1235 11.998C19.1235 13.0261 18.9189 14.0439 18.5217 14.9921C18.1244 15.9404 17.5425 16.8001 16.8097 17.5212C16.0769 18.2423 15.2079 18.8104 14.2534 19.1924C13.2989 19.5743 12.278 19.7625 11.25 19.746C9.19492 19.746 7.22398 18.9298 5.77063 17.4768C4.31728 16.0238 3.50053 14.0531 3.5 11.998Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/Loupe.a79a53e50b63e088c8dc1e779c477090.svg";
export { ForwardRef as ReactComponent };